// Identidad de acceso de un usuario, para MOSTRAR.
//
// Los usuarios sin correo real (líderes/supervisores de planta) entran con su
// CÉDULA: el sistema les arma un email sintético `{cédula}@dominio` solo para
// satisfacer a GoTrue (email-first). Ese string NO es un contacto — es su
// identificador de acceso. Si lo mostramos crudo, parece un correo y confunde.
//
// `identidadUsuario` detecta el caso (la parte local del email son solo dígitos)
// y devuelve la cédula etiquetada; para correos reales, devuelve el correo.

export type IdentidadUsuario = {
  /** true si el login es por cédula (email sintético) */
  esCedula: boolean;
  /** la cédula (si esCedula) o el correo real */
  valor: string;
  /** texto listo para mostrar: "Cédula · 123456" o el correo */
  etiqueta: string;
};

export function identidadUsuario(email: string | null | undefined): IdentidadUsuario {
  const e = (email ?? '').trim();
  const local = e.split('@')[0] ?? '';
  const esCedula = local.length > 0 && /^\d+$/.test(local);
  return esCedula
    ? { esCedula: true, valor: local, etiqueta: `Cédula · ${local}` }
    : { esCedula: false, valor: e, etiqueta: e };
}
